<template >
  <transition name="modal">
    <v-dialog v-model="dialog" >
      <v-card id="search" class="anadir-cita ">
        <v-toolbar flat class="d-flex justify-space-between">
          <v-toolbar-title class="primary-color"><v-icon class="mr-2 primary-color">edit_calendar</v-icon>Fichaje</v-toolbar-title>
          <v-btn @click="$emit('close')"
            icon
            flat
            class="primary-color">
          <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <h3 class="modal-header px-4 pt-4 pb-2">
          <slot name="header">
            {{ fecha }}
          </slot>
        </h3>
          <div class="modal-body px-4 pb-4">
            <div class="modal-detalle-info">
              <span class="detalle-fichaje-titulo">Total:</span> <span>{{ dia.duracionHoras }}</span> <br>
              <span class="detalle-fichaje-titulo">Horario:</span> <span>{{ dia.horario }}</span> <br>  
              <span class="detalle-fichaje-titulo">Tipo:</span> <span>{{ dia.tipoJornada }}</span> <br>
            </div>
            <table class='mt-4' cellspacing='0' cellpadding='0' border=0 width='100%'>
            <tr>
              <td>
                <table width='100%'>
                  <tr class="detalle-fichaje-titulo">
                    <th scope='row' width='25%'>{{ tableTitulos.tipo }}</th>
                    <th scope='row' width='25%'>{{ tableTitulos.hora }}</th>
                    <th scope='row' width='50%'>{{ tableTitulos.obs }}</th>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <div style='width:100%; height:200px; overflow:auto;'>
                  <table cellspacing='0' cellpadding='1' width='100%' class="tabla-detalle-fichaje">
                    <tr v-for='ficha in dia.fichaje' :key='ficha.msfichajeid'
                     :class="{'tr-detalle-fichaje bg-entrada' : ficha.msfichajetipostr === 'E', 'tr-detalle-fichaje bg-pausa' : ficha.msfichajetipostr === 'P', 'tr-detalle-fichaje bg-final' : ficha.msfichajetipostr === 'S' }"> 
                      <td width='25%'>
                        <small>
                          {{ ficha.msfichajetipostr }} <br>
                        </small>
                      </td>
                      <td width='25%'>
                        <small >
                          {{ ficha.msfichajehora }} <br>
                        </small>
                      </td>
                      <td width='50%'>
                        <small>
                          {{ ficha.msfichajeobs }} <br>
                        </small>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </table>
          </div>
      </v-card>
    </v-dialog>
  </transition>
</template>
<script>
export default {
  props: {
    dia: { 
      type: Object, 
      required: true,
    },
    fecha: String,
    dialog: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      tableTitulos: {
        fecha: this.$t('lang.comun.fecha'),
        tipo: this.$t('lang.comun.tipo'),
        hora: this.$t('lang.comun.hora'),
        obs: this.$t('lang.comun.obs'),
        total: this.$t('lang.comun.total'),
        parcial: this.$t('lang.comun.parcial')
      },
    }
  },
  methods: {

  },
  created() {
  }

}
</script>
<style>
.tr-detalle-fichaje.bg-entrada {
  background-color: rgba(144, 238, 144, 0.6) !important;
}
.tr-detalle-fichaje.bg-pausa {
  background-color: rgb(255, 255, 224, 0.6) !important;
}
.tr-detalle-fichaje.bg-final {
  background-color: rgb(173, 216, 230, 0.6) !important;
}
.tr-detalle-fichaje.transparente {
  background-color: rgba(255, 255, 255, 0.9) !important;
}
.tr-detalle-fichaje td{
  padding: 4px;
}
.detalle-fichaje-titulo {
    color: #616161 !important;
    caret-color: #616161 !important;
    font-size: 14px;
  }
.detalle-fichaje-titulo th {
  text-align: left;
}

.tabla-detalle-fichaje {
  font-size: 15px;
  margin-top: 5px;
}
.modal-detalle-info {
  font-size: 15px;
  margin-bottom: 15px;
}
.modal-detalle-info span{
  padding: 5px 5px 0 0;
}
</style>